import React from 'react'
import {IconProps} from '../../types/IconProps'

const SummaryIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M7.2 7.09091C7.2 6.63904 7.55818 6.27273 8 6.27273H16C16.4418 6.27273 16.8 6.63904 16.8 7.09091C16.8 7.54277 16.4418 7.90909 16 7.90909H8C7.55817 7.90909 7.2 7.54277 7.2 7.09091Z'
        fill='#666666'
      />
      <path
        d='M7.2 10.3636C7.2 9.91176 7.55818 9.54545 8 9.54545H16C16.4418 9.54545 16.8 9.91176 16.8 10.3636C16.8 10.8155 16.4418 11.1818 16 11.1818H8C7.55817 11.1818 7.2 10.8155 7.2 10.3636Z'
        fill='#666666'
      />
      <path
        d='M8 12.8182C7.55818 12.8182 7.2 13.1845 7.2 13.6364C7.2 14.0882 7.55817 14.4545 8 14.4545H16C16.4418 14.4545 16.8 14.0882 16.8 13.6364C16.8 13.1845 16.4418 12.8182 16 12.8182H8Z'
        fill='#666666'
      />
      <path
        d='M7.2 16.9091C7.2 16.4572 7.55818 16.0909 8 16.0909H11.2C11.6418 16.0909 12 16.4572 12 16.9091C12 17.361 11.6418 17.7273 11.2 17.7273H8C7.55818 17.7273 7.2 17.361 7.2 16.9091Z'
        fill='#666666'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 5.45455C4 4.09894 5.07452 3 6.4 3H17.6C18.9255 3 20 4.09894 20 5.45455V18.5455C20 19.9011 18.9255 21 17.6 21H6.4C5.07452 21 4 19.9011 4 18.5455V5.45455ZM6.4 4.63636H17.6C18.0418 4.63636 18.4 5.00267 18.4 5.45455V18.5455C18.4 18.9973 18.0418 19.3636 17.6 19.3636H6.4C5.95818 19.3636 5.6 18.9973 5.6 18.5455V5.45455C5.6 5.00268 5.95817 4.63636 6.4 4.63636Z'
        fill={color || '#666666'}
      />
    </svg>
  )
}

export default SummaryIcon
